const regex = /([a-z])([A-Z])/g;
const breakpointNameToAttribute = (breakpointName) => breakpointName.replace(regex, '$1-$2').toLowerCase();
export { breakpointNameToAttribute };
